
<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Seviye Ekle/Güncelle</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="definitionForm">
    <div class="modal-body">
  

      <div class="form-group">
        <label>Adı</label>

        <input type="text" formControlName="name" class="form-control">
      </div>
      <div class="form-group">
        <label>Başlık</label>

        <input type="text" formControlName="header" class="form-control">
      </div>
      <div class="form-group">
        <label>Açıklama</label>

        <input type="text" formControlName="description" class="form-control">
      </div>
      <div class="form-group">
        <label>Sıra</label>

        <input type="text" formControlName="order" class="form-control">
      </div>

      <div class="form-group">
        <label>Renk Kodu</label>

        <input type="text"   [(colorPicker)]="color" [style.background]="color">
      </div>
      
      <div class="form-group">
        <label> <input type="checkbox" formControlName="isPremium"> Premium</label>

       
      </div>

      <div class="row mt-2">
        <div class="col-md-12">
          <h4>İkon <div *ngIf="data"><img src="{{data.iconUrl}}"></div></h4>
          <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="SelectSingleFile($event)">
            <ngx-dropzone-label>
                <div class="dz-default dz-message">
                    <span class = "dz-default">Dosyayı buraya sürükleyin yada seçmek için tıklayın<br/>Lütfen png yada jpg Dosyası yükleyin</span>
                </div>
            </ngx-dropzone-label>
            <ngx-dropzone-image-preview  ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="SinglefileonRemove(f)">
                <ngx-dropzone-label class="dropzone1 text-center">{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-image-preview>
        </div>
       
       
      
      </div>
    </div>

     
    </div>

    <div class="modal-footer">
      <button type="reset" class="btn grey btn-outline-secondary btn-lg"
        (click)="close()">Kapat</button>
      <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Kaydet</button>
    </div>
  </form>
</div>

